import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AdminProductsState } from './admin-products.state';

export const selectAdminProductsState = createFeatureSelector<AdminProductsState>('adminProducts');

export const selectAdminProductsList = createSelector(
  selectAdminProductsState,
  (state) => state.products
);

export const selectAdminProductsLoading = createSelector(
  selectAdminProductsState,
  (state) => state.isLoading
);

export const selectAdminTotalElements = createSelector(
  selectAdminProductsState,
  (state) => state.totalElements
);

export const selectAdminTotalPages = createSelector(
  selectAdminProductsState,
  (state) => state.totalPages
);

export const selectAdminCurrentPage = createSelector(
  selectAdminProductsState,
  (state) => state.currentPage
);

export const selectAdminError = createSelector(
    selectAdminProductsState,
    (state) => state.error
);
